import { useEffect, useMemo, type ReactNode } from "react";
import {
  defaultLocale,
  getLocaleDirection,
  getMessagesForLocale,
  isSupportedLocale,
  type PortalLocale,
} from "@/lib/i18n/portal";
import {
  I18nContext,
  type I18nContextValue,
  type MessageCatalog,
} from "@/lib/i18n/intl";

function getResolvedLocale(locale: string): PortalLocale {
  return isSupportedLocale(locale) ? locale : defaultLocale;
}

export function AdminIntlProvider({
  children,
  locale,
}: {
  children: ReactNode;
  locale: string;
}) {
  const resolvedLocale = getResolvedLocale(locale);
  const value = useMemo<I18nContextValue>(
    () => ({
      locale: resolvedLocale,
      messages: getMessagesForLocale(resolvedLocale) as MessageCatalog,
    }),
    [resolvedLocale],
  );

  useEffect(() => {
    document.documentElement.lang = resolvedLocale;
    document.documentElement.dir = getLocaleDirection(resolvedLocale);
  }, [resolvedLocale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
